import { ProductDoc } from '@gooduncles/gu-app-schema';
import { ComponentType, FC } from 'react';

import useProductById from 'src/hooks/swr/useProductById';

interface WithProductProps {
  productId: ProductDoc['_id'];
}

interface WithProductInjectedProps {
  product: ProductDoc;
}

// HOC 정의: productId를 받아 Product 데이터를 주입
const withProduct = <P extends WithProductInjectedProps>(
  WrappedComponent: ComponentType<P>
): FC<Omit<P, keyof WithProductInjectedProps> & WithProductProps> => {
  const WithProduct: FC<Omit<P, keyof WithProductInjectedProps> & WithProductProps> = (props) => {
    const { productId, ...rest } = props;
    const { product, productLoading, productError } = useProductById(productId);

    // 로딩 중일 때
    if (productLoading) {
      return <div>로딩 중...</div>;
    }

    // 에러 발생 시
    if (productError) {
      return <div>상품 정보를 불러오는데 실패했습니다.</div>;
    }

    // 데이터가 없을 때
    if (!product) {
      return <div>상품 정보가 없습니다.</div>;
    }

    // 데이터가 있으면 컴포넌트에 주입
    return <WrappedComponent {...(rest as any)} product={product} />;
  };

  return WithProduct;
};

export default withProduct;
